import React, { useState, useEffect } from "react";
import { Box, Select, MenuItem } from "@material-ui/core";
import {
  useStyles,
} from "examsbook-react-sdk/custom-hooks";
import i18n from "examsbook-react-sdk/translations";
import { useDispatch, useSelector } from "react-redux";
import { languageAction } from 'examsbook-react-sdk/actions/languageAction';
import { updateUser } from "examsbook-react-sdk/actions/getUser";

export const LanguageSelect = () => {
  const defaultLanguage = useSelector((state) => state.getLanguaggeReducer.lang) || "en";
  const [language, setLanguage] = useState(defaultLanguage);
  const user = useSelector((state) => state.user);
  const userId = user?.user?._id ? user?.user?._id : user?._id;
  const dispatch = useDispatch();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);

    // Always update localStorage and i18n
    i18n.changeLanguage(selectedLanguage);
    dispatch(languageAction(selectedLanguage));
    // Only update user profile if user is authenticated
    if (userId) {
      dispatch(updateUser(userId, { language: selectedLanguage }));
    }
  };

  const styles = {
    languageSelect: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
      marginBottom: 12,
      position: "absolute",
      right: '10rem',
      top: '2rem',
      zIndex: 10,

      "@media only screen and (max-width: 767px)": {
        justifyContent: "flex-end",
        marginBottom: 8,
        right: '0',
      },
      "@media only screen and (min-width: 768px) and (max-width: 1300px)": {
        justifyContent: "flex-end",
        marginBottom: 8,
        right: '1rem',
      },
    },
  };

  const classes = useStyles(styles)();

  return (
    <Box className={classes.languageSelect}>
      <Select
        id="language-select"
        value={language}
        onChange={handleLanguageChange}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="hn">हिंदी</MenuItem>
      </Select>
    </Box>
  );
};